import React from 'react';
import { Select } from '@mantine/core';
import backarrow from 'assets/icons/backArrowIcon.svg';
import sendicon from 'assets/icons/senticon2.svg';
import printicon from 'assets/icons/printIcon.svg';
import archiveicon from 'assets/icons/archiveicon2.svg';
import deleteicon from 'assets/icons/junkicon2.svg';

import { ReactComponent as Downarrowicon } from 'assets/icons/downArrow.svg';
import useGetMailFolders from '../hooks/useGetMailFolders';
import useCopyMailToFolder from '../hooks/useCopyMailToFolder';

const Emailfeatures = ({ selectedEmail }) => {
  let folders = [];
  folders = useGetMailFolders()?.data?.data?.map((folder) => {
    return { value: folder?.id, label: folder?.name, id: folder?.id };
  });

  const usecopymailtofolder = useCopyMailToFolder();

  return (
    <div className='flex justify-between items-center fixed h-[4rem] bg-white w-[47%] z-10  -translate-y-4'>
      <div className='flex gap-x-8 items-center'>
        <img
          src={backarrow}
          alt='backbutton'
          className='cursor-pointer w-4 h-4 2xl:w-6 3xl:w-8'
        />

        <Select
          placeholder='Add to a folder'
          rightSection={
            <Downarrowicon className='w-3 h-4 2xl:w-4 2xl:h-5 3xl:w-5 3xl:h-6' />
          }
          rightSectionWidth={30}
          styles={{ rightSection: { pointerEvents: 'none' } }}
          data={folders}
          onChange={(e) => {
            usecopymailtofolder.mutate({
              folder_id: e,
              id: selectedEmail[0]?.id,
            });
          }}
          classNames={{
            wrapper: 'border-primary border-b',
            input:
              'w-32 border-none  font-light text-000000 text-sm 2xl:w-34 2xl:text-lg 3xl:w-40 3xl:text-xl',
          }}
        />
      </div>

      <div className='flex gap-x-4 items-center invisible'>
        {
          // this section is made invisible as features are repetative
        }
        <div className='flex gap-x-2 xl:gap-x-1 2xl:gap-x-4 3xl:gap-x-5'>
          <div className='gap-1 flex cursor-pointer items-center p-1 rounded hover:bg-F8F7F7'>
            <img
              src={sendicon}
              alt='sendicon'
              className='w-4 2xl:w-5 3xl:w-7'
            />
            <h1 className='text-808080 text-xs 2xl:text-sm 3xl:text-lg xl:text-sm'>
              Send
            </h1>
          </div>
          <div className='gap-1 flex cursor-pointer p-1 hover:bg-F8F7F7'>
            <img
              src={archiveicon}
              alt='archiveicon'
              className='w-4 2xl:w-5 3xl:w-7'
            />
            <h1 className='text-808080  text-xs 2xl:text-sm 3xl:text-lg xl:text-sm'>
              Archive
            </h1>
          </div>
          <div className='gap-1 flex cursor-pointer p-1 hover:bg-F8F7F7'>
            <img
              src={deleteicon}
              alt='deleteicon'
              className='w-4 2xl:w-5 3xl:w-7'
            />
            <h1 className='text-808080  text-xs 2xl:text-sm 3xl:text-lg xl:text-sm'>
              Delete
            </h1>
          </div>

          <div className='gap-1 flex cursor-pointer p-1 hover:bg-F8F7F7'>
            <img
              src={printicon}
              alt='printicon'
              className='w-4 2xl:w-5 3xl:w-7 '
            />
            <h1 className='text-808080 text-xs 2xl:text-sm 3xl:text-lg xl:text-sm'>
              Print
            </h1>
          </div>
        </div>
        <div className='flex gap-x-2'>
          <Select
            rightSection={<Downarrowicon size={14} />}
            rightSectionWidth={30}
            defaultValue='english'
            disabled
            styles={{ rightSection: { pointerEvents: 'none' } }}
            data={[
              { value: 'english', label: 'En' },
              { value: 'telegu', label: 'Te' },
            ]}
            classNames={{
              wrapper: '',
              input:
                'w-20 border-none font-bold text-000000 text-xl text-primary 2xl:text-2xl 3xl:text-2xl',
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default Emailfeatures;
